export default __webpack_public_path__ + "static/medical_assistance-796a7a99950c603eea162f421909257d.png";